<template>
  <div>
    <div class="title-h3 title-bar">구성 정보</div>
    <hr class="mr-b20" />
    <el-row v-loading="isLoading" type="flex" justify="space-between" :gutter="20" class="mr-t5">
      <el-col :span="24">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">기본 정보</div>
              <div class="list form-list">
                <el-form ref="configForm" :model="formData" label-width="120px" :rules="configRules">
                  <el-form-item label="장비명">
                    <w-text-form :modifiable="modifiable" :target="formData" property="objName"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="IP 종류">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="iptypeList" option-key="ipaddressApplytype" property="ipaddressApplytype" labelprop="label"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="IPv4" prop="ipaddressIpv4">
                    <w-text-form :modifiable="modifiable" :target="formData" property="ipaddressIpv4"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="IPv6" prop="ipaddressIpv6">
                    <w-text-form :modifiable="modifiable" :target="formData" property="ipaddressIpv6"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="서브넷마스크">
                    <w-text-form :modifiable="modifiable" :target="formData" property="objSubnetmask"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="MAC 주소">
                    <w-text-form :modifiable="modifiable" :target="formData" property="objMacaddress"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="장비 종류">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="objTypeList" option-key="label, objtypeName" property="objtypeId" labelprop="objtypeName"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="제조사">
                    <w-select-form search="true" :modifiable="modifiable" :target="formData" @change="companyChange" :option-list="objCompanyList" option-key="objCompanyId" property="objCompanyId" labelprop="objCompanyName"> </w-select-form>
                    <el-button v-if="modifiable" @click="openCompanyListPopup"><i class="fas fa-search"></i></el-button>
                  </el-form-item>
                  <el-form-item label="모델">
                    <w-select-form search="true" :modifiable="modifiable" :target="formData" :option-list="filteredProducts" option-key="objCompanyId, objProductId" property="objProductId" labelprop="objProductId"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="구동 시간">
                    <w-text-form :modifiable="modifiable" :target="formData" property="netdeviceUptimeCount" use-slot="true">
                      <span slot="data"> {{ convertUptimeCount(formData.netdeviceUptimeCount) }} </span>
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="설명">
                    <w-text-form :modifiable="false" :target="formData" property="netdeviceDesc"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="판매 종료일 (EOL)">
                    <w-text-form :modifiable="false" :target="formData" property="eolDate" use-slot="true">
                      <span slot="data"> {{ convertDate(formData.eolDate) }} </span>
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="서비스 종료일 (EOS)">
                    <w-text-form :modifiable="false" :target="formData" property="eosDate" use-slot="true">
                      <span slot="data"> {{ convertDate(formData.eosDate) }} </span>
                    </w-text-form>
                  </el-form-item>
                  <el-form-item label="중요도">
                    <w-obj-importance-form-editor :modifiable="modifiable" :target="formData" property="objImportance"> </w-obj-importance-form-editor>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class=" mr-b30">
              <div class="title-h4 title-bar">장비 접속 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="접속 방법">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="connetTypeList" option-key="label" property="useSSH" labelprop="label"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="Telnet Port">
                    <w-number-form :modifiable="modifiable" :target="formData" property="telnetPort"> </w-number-form>
                  </el-form-item>
                  <el-form-item label="SSH Port">
                    <w-number-form :modifiable="modifiable" :target="formData" property="sshPort"> </w-number-form>
                  </el-form-item>
                  <el-form-item label="1차 접속 ID">
                    <w-text-form :modifiable="modifiable" :target="formData" property="telnetuserId1"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="1차 패스워드">
                    <w-text-form :modifiable="modifiable" :target="formData" property="telnetuserPw1" type="password"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="2차 접속 ID">
                    <w-text-form :modifiable="modifiable" :target="formData" property="telnetuserId2"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="2차 패스워드">
                    <w-text-form :modifiable="modifiable" :target="formData" property="telnetuserPw2" type="password"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <!-- 구성 OID 설정 정보 -->
            <el-row class=" mr-b30" v-if="templateAttrValueList.length > 0">
              <div class="title-h4 title-bar">확장 정보</div>
              <div class="list form-list">
                <el-form :model="formDataAttr" label-width="120px">
                  <el-form-item v-for="item in templateAttrValueList" :key="item.targetAttrId" :label="item.targetAttrName">
                    <span class="h100 w100">
                      <span v-if="item.attrValue">
                        <div v-for="(target, targetIndex) in item.attrValue.split(',')" :key="targetIndex">
                          {{ target }}
                        </div>
                      </span>
                      <span v-else>-</span>
                    </span>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">HW/SW 정보</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="무선 AP 수">
                    <w-text-form :modifiable="false" :target="formData" property="apCount"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="CPU">
                    <w-text-form :modifiable="modifiable" :target="formData" property="cpuModel"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="DRAM 크기">
                    <w-text-form :modifiable="modifiable" :target="formData" property="dram"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="NVRAM 크기">
                    <w-text-form :modifiable="modifiable" :target="formData" property="nvram"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="플래시 크기">
                    <w-text-form :modifiable="modifiable" :target="formData" property="flashSize"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="시리얼 넘버">
                    <w-text-form :modifiable="modifiable" :target="formData" property="serialNumber"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="마더보드 시리얼 넘버">
                    <w-text-form :modifiable="modifiable" :target="formData" property="motherboardSerialNumber"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="마더보드 리비전 넘버">
                    <w-text-form :modifiable="modifiable" :target="formData" property="motherboardRevisionNumber"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="파워 서플라이 파트 넘버">
                    <w-text-form :modifiable="modifiable" :target="formData" property="powerSupplyPartNumber"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="최근 재부팅 사유">
                    <w-text-form :modifiable="modifiable" :target="formData" property="rebootReason"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="컨피그 레지스터">
                    <w-text-form :modifiable="modifiable" :target="formData" property="configRegister"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="OS 버전">
                    <w-text-form :modifiable="modifiable" :target="formData" property="osVersion"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="펌웨어 이미지">
                    <w-select-form search="true" selfinput="true" :modifiable="modifiable" :target="formData" :option-list="firmwareList" option-key="fileName" property="fileName" labelprop="fileName"> </w-select-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">동작 상태 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="동작상태 감지 방법">
                    <w-checkgroup-form :modifiable="modifiable" :target="formData" :option-list="aliveOptionList"> </w-checkgroup-form>
                  </el-form-item>
                  <el-form-item label="TCP 포트 감지">
                    <w-number-form :modifiable="modifiable" :target="formData" property="alivecheckTcpPort"> </w-number-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">SNMP 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="커뮤니티 읽기">
                    <w-text-form :modifiable="modifiable" :target="formData" property="snmpCommunityRead" type="password"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="커뮤니티 읽기/쓰기">
                    <w-text-form :modifiable="modifiable" :target="formData" property="snmpCommunityReadwrite" type="password"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="버전">
                    <w-select-form :modifiable="modifiable" :target="formData" :option-list="snmpVersionList" option-key="snmpVersion" property="snmpVersion" labelprop="label"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="포트">
                    <w-number-form :modifiable="modifiable" :target="formData" property="snmpPort"> </w-number-form>
                  </el-form-item>
                </el-form>
              </div>
              <div v-if="isSnmpv3" class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="USER">
                    <w-text-form :modifiable="modifiable" :target="formData" property="snmpV3Username"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="Context 명">
                    <w-text-form :modifiable="modifiable" :target="formData" property="snmpV3ContextName"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="Context ID">
                    <w-text-form :modifiable="modifiable" :target="formData" property="snmpV3ContextId"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="Auth 프로토콜">
                    <w-select-form @change="authChange" :modifiable="modifiable" :target="formData" :option-list="snmpV3AuthList" option-key="snmpV3AuthProtocol" property="snmpV3AuthProtocol" labelprop="label"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="Auth 비밀번호">
                    <w-text-form :modifiable="hasAutoProtocol" :target="formData" property="snmpV3AuthPassword" type="password"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="Privacy 프로토콜">
                    <w-select-form @change="privChange" :modifiable="modifiable" :target="formData" :option-list="snmpV3PrivList" option-key="snmpV3PrivProtocol" property="snmpV3PrivProtocol" labelprop="label"> </w-select-form>
                  </el-form-item>
                  <el-form-item label="Privacy 비밀번호">
                    <w-text-form :modifiable="hasPrivProtocol" :target="formData" property="snmpV3PrivPassword" type="password"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">관리자/유지보수 정보</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="관리자(정)">
                    <el-select v-if="modifiable" ref="selectEditor" v-model="formData.objManagerIdMajor" :filterable="true" default-first-option controls-position="right" size="mini" clearable>
                      <el-option v-for="option in managerList" :key="option.managerId" :label="option.mapLabel" :value="option.managerId"> </el-option>
                    </el-select>
                    <span v-else> {{ getObjManagerName(formData.objManagerIdMajor) }} </span>
                  </el-form-item>
                  <el-form-item label="관리자(부)">
                    <el-select v-if="modifiable" ref="selectEditor" v-model="formData.objManagerIdMinor" :filterable="true" default-first-option controls-position="right" size="mini" clearable>
                      <el-option v-for="option in managerList" :key="option.managerId" :label="option.mapLabel" :value="option.managerId"> </el-option>
                    </el-select>
                    <span v-else> {{ getObjManagerName(formData.objManagerIdMinor) }} </span>
                  </el-form-item>
                  <el-form-item label="유지보수 업체">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceCompany"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="유지보수 담당자">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceManager"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="유지보수 연락처">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceTel"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">프로토콜 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="ICMP 시도횟수">
                    <w-number-form :modifiable="modifiable" :target="formData" property="icmpTrycount"> </w-number-form>
                  </el-form-item>
                  <el-form-item label="ICMP 타임아웃(ms)">
                    <w-number-form :modifiable="modifiable" :target="formData" property="icmpTimeout"> </w-number-form>
                  </el-form-item>
                  <el-form-item label="ICMP 패킷크기(byte)">
                    <w-number-form :modifiable="modifiable" :target="formData" property="icmpDatasize"> </w-number-form>
                  </el-form-item>
                  <el-form-item label="ICMP CLI Ping">
                    <w-check-form :modifiable="modifiable" :target="formData" property="icmpClipingApplyFlag" tf-type="Number"> </w-check-form>
                  </el-form-item>
                  <el-form-item label="SNMP 시도횟수">
                    <w-number-form :modifiable="modifiable" :target="formData" property="snmpTrycount"> </w-number-form>
                  </el-form-item>
                  <el-form-item label="SNMP 타임아웃(ms)">
                    <w-number-form :modifiable="modifiable" :target="formData" property="snmpTimeout"> </w-number-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">Application Link 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="Link">
                    <w-text-form :modifiable="modifiable" :target="formData" property="linkWwwUrl"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="Application">
                    <w-text-form :modifiable="modifiable" :target="formData" property="linkAppPath"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">이벤트 제외 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="이벤트 제외">
                    <w-check-form :modifiable="modifiable" :target="formData" property="eventExceptFlag"> </w-check-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">네트워크 설정</div>
              <div class="list form-list">
                <span style="display:flex;">
                  <el-form :model="formData" label-width="120px">
                    <el-form-item label="보조 IP">
                      <div v-html="subIpInfostr"></div>
                    </el-form-item>
                  </el-form>
                  <w-subip-info style="margin-left:5px;" :visible="modifiable" :modifiable="modifiable" :subIpInfo="formData.subIpInfo" :objId="formData.objId" @updateSubIp="updateSubIp"></w-subip-info>
                </span>
              </div>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <w-product-company-popup ref="companyListPopup" @select-company-id="applyCompanyId"></w-product-company-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { checkNetdeviceObjDefine } from '@/utils/wireless-device';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import MsgUtil from '@/utils/message';
import Editingf from '@/mixins/editingForm';
import { cloneDeep, isNil, eq, isEmpty, assign, has } from 'lodash';
import { createEncryptTargetData, getRsaEncrypt } from '@/utils/rsa-encrypt';
// api
import ndInfoAPI from '@/api/config/netdevice/netdevice-info';
import commonAPI from '@/api/config/common';
// for edit cmp
import WTextForm from '@/components/formeditor/TextFormEditor';
import WNumberForm from '@/components/formeditor/NumberFormEditor';
import WSelectForm from '@/components/formeditor/SelectFormEditor';
import WCheckgroupForm from '@/components/formeditor/CheckGroupFormEditor';
import WCheckForm from '@/components/formeditor/CheckFormEditor';
import WObjImportanceFormEditor from '@/components/formeditor/ObjImportanceFormEditor';
import WProductCompanyPopup from '@/views/config/node/netdevice/popup/ProductCompanyPopup';
import wSubipInfo from '@/views/config/node/netdevice/configstatus/components/subipInfo';

const iptypeList = [
  {
    label: 'IPv4',
    ipaddressApplytype: 'IPv4',
  },
  {
    label: 'IPv6',
    ipaddressApplytype: 'IPv6',
  },
];

const connetTypeList = [
  {
    label: 'SSH',
    useSSH: true,
  },
  {
    label: 'Telnet',
    useSSH: false,
  },
];

export default {
  name: 'WApControllerConfigStatus',
  components: {
    ndInfoAPI,
    WTextForm,
    WNumberForm,
    WSelectForm,
    WCheckgroupForm,
    WCheckForm,
    WObjImportanceFormEditor,
    wSubipInfo,
    WProductCompanyPopup,
  },
  mixins: [Editingf],
  props: {
    nodeParams: {
      type: Object,
    },
  },
  data() {
    return {
      // customer,
      isLoading: true,
      basicInfoLoadFlag: false,
      false: false,
      iptypeList,
      connetTypeList,
      // Reject데이터
      objOriginData: {},
      formData: {},
      formDataAttr: {},
      originalSubIpInfo: [],
      objTypeList: [],
      objCompanyList: [],
      objProductList: [],
      // skccCustomerList: [],
      managerList: [],
      firmwareList: [],
      aliveOptionList: [],
      snmpVersionList: [],
      snmpV3AuthList: [],
      snmpV3PrivList: [],
      templateAttrValueList: [
        {
          columnName: '구성 정보 필드',
          attrValue: '-',
        },
      ],
      attrMap: {
        cpuModel: {
          attrTypeId: 'HARDWARE',
          attrId: 'CPU_MODEL',
        },
        osVersion: {
          attrTypeId: 'OS',
          attrId: 'OS_VERSION',
        },
        // firmwareFile: {
        fileName: {
          attrTypeId: 'FIRMWARE',
          attrId: 'FIRMWARE_FILE',
        },
        configRegister: {
          attrTypeId: 'HARDWARE',
          attrId: 'CONFIG_REGISTER',
        },
        serialNumber: {
          attrTypeId: 'HARDWARE',
          attrId: 'SYSTEM_SERIAL_NUMBER',
        },
        moduleSerialNumber: {
          attrTypeId: 'MODULE',
          attrId: 'SERIAL_NUMBER',
        },
        powerSupplyPartNumber: {
          attrTypeId: 'HARDWARE',
          attrId: 'POWERSUPPLY_PART_NUMBER',
        },
        flashSize: {
          attrTypeId: 'HARDWARE',
          attrId: 'FLASH_SIZE',
        },
        dram: {
          attrTypeId: 'HARDWARE',
          attrId: 'DRAM',
        },
        nvram: {
          attrTypeId: 'HARDWARE',
          attrId: 'NVRAM',
        },
        motherboardSerialNumber: {
          attrTypeId: 'HARDWARE',
          attrId: 'MOTHERBOARD_SERIAL_NUMBER',
        },
        motherboardRevisionNumber: {
          attrTypeId: 'HARDWARE',
          attrId: 'MOTHERBOARD_REVISION_NUMBER',
        },
        rebootReason: {
          attrTypeId: 'HARDWARE',
          attrId: 'REBOOT_REASON',
        },
      },
    };
  },
  computed: {
    ...mapGetters(['configRules', 'rejectConfigEditing', 'saveConfigEditing']),
    params() {
      return {
        objId: this.nodeParams.objId,
      };
    },
    modifiable() {
      return this.$store.state.config.isConfigEditing;
    },
    isSnmpv3() {
      return eq('V3', this.formData.snmpVersion) ? true : this.false;
    },
    hasAutoProtocol() {
      return !eq('NONE', this.formData.snmpV3AuthProtocol) ? this.modifiable : this.false;
    },
    hasPrivProtocol() {
      return !eq('NONE', this.formData.snmpV3PrivProtocol) ? this.modifiable : this.false;
    },
    filteredProducts() {
      return this.objProductList.filter((c) => c.objCompanyId === this.formData.objCompanyId);
    },
    subIpInfostr() {
      let subIpInfostr = '';
      const subIpInfo = this.formData.subIpInfo;

      if (subIpInfo && subIpInfo.length > 0) {
        const length = subIpInfo.length;
        subIpInfo.forEach((st, idx) => {
          subIpInfostr += st.ipAddress;
          if (length > 1 && idx !== length - 1) subIpInfostr += '<br />';
        });
      } else {
        subIpInfostr = EMPTY_TEXT;
      }

      return subIpInfostr;
    },
  },
  watch: {
    params: {
      immediate: true,
      handler() {
        if (this.modifiable) {
          // 대상 변경 시 수정모드 종료
          this.$store.dispatch('setConfigEditing', false);
        }
        if (this.params.objId) {
          this.loadData();
        }
      },
    },
    rejectConfigEditing: {
      immediate: true,
      handler(to) {
        if (to) {
          this.initAliveChechGroup(this.objOriginData);
          this.formData = Object.assign({}, this.objOriginData);
          this.$store.dispatch('initRejectConfig');
        }
      },
    },
    saveConfigEditing: {
      immediate: true,
      handler(to) {
        if (to) {
          this.$refs.configForm.validate((valid) => {
            if (valid) {
              this.$confirm(...MsgUtil.getBasicConfirmData(MsgUtil.action.SAVE))
                .then(() => {
                  const attrMap = this.attrMap;
                  const formData = this.formData;
                  const infoParams = Object.assign({}, formData);
                  const modifiedData = formData.modified;
                  let updateData = {
                    objId: infoParams.objId,
                    objName: infoParams.objName,
                    ncmId: infoParams.ncmId,
                    objImportance: formData.objImportance, // null이면 delete로 판단하므로 값 변경이 없을 경우에도 서버단에 전달한다.
                  };
                  const updateAttrList = [];

                  // 수정된값들
                  if (modifiedData && Object.keys(modifiedData).length > 0) {
                    Object.keys(modifiedData).forEach((key) => {
                      if (has(attrMap, key)) {
                        const attr = Object.assign({}, attrMap[key]);
                        Object.assign(attr, {
                          ncmId: formData.ncmId,
                          attrKey: 0,
                          attrValue: formData[key],
                        });
                        updateAttrList.push(attr);
                      } else {
                        updateData[key] = formData[key];

                        if (eq('snmpV3AuthProtocol', key) && eq(formData[key], 'NONE')) {
                          updateData.snmpV3AuthPassword = '';
                        }

                        if (eq('snmpV3PrivProtocol', key) && eq(formData[key], 'NONE')) {
                          updateData.snmpV3PrivPassword = '';
                        }
                      }
                    });
                  }

                  if (this.objOriginData.objManagerIdMajor !== formData.objManagerIdMajor) {
                    updateData.objManagerIdMajor = formData.objManagerIdMajor;
                  }

                  if (this.objOriginData.objManagerIdMinor !== formData.objManagerIdMinor) {
                    updateData.objManagerIdMinor = formData.objManagerIdMinor;
                  }

                  updateData.attrStr = JSON.stringify(updateAttrList);
                  updateData = checkNetdeviceObjDefine(updateData);
                  const target = '구성 정보';
                  const action = MsgUtil.action.SAVE;
                  const encryptTargetData = createEncryptTargetData(updateData, ['telnetuserPw1', 'telnetuserPw2', 'snmpCommunityRead', 'snmpCommunityReadwrite', 'snmpV3AuthPassword', 'snmpV3PrivPassword']);
                  if (encryptTargetData !== null) {
                    getRsaEncrypt(encryptTargetData)
                      .then((encryptData) => {
                        this.saveConfig(assign(updateData, encryptData), action, target);
                      })
                      .catch((e) => {
                        this.$message(MsgUtil.getResultMsgData(action, target, false));
                        throw new Error(e);
                      });
                  } else {
                    this.saveConfig(updateData, action, target);
                  }
                })
                .catch(() => {
                  this.$store.dispatch('setSaveConfigEditing', false);
                });
            } else {
              this.$store.dispatch('setSaveConfigEditing', false);
            }
          });
        }
      },
    },
  },
  methods: {
    getDateToString,
    convertValuByUnit,
    getValueAfterCheckEmpty,
    loadData() {
      this.isLoading = true;
      // 최초 한번만 실행
      if (!this.basicInfoLoadFlag) {
        this.setBasicInfoData();
      }
      this.objOriginData = {};
      const basicConfig = () =>
        ndInfoAPI.getNdConfigInfoBasic(this.params).then((result) => {
          if (result.data.success) {
            const data = result.data.data;
            const subIpInfo = data.subIpInfo;

            this.originalSubIpInfo = subIpInfo;

            this.initAliveChechGroup(data);

            if (data && !has(data, 'objCompanyId')) {
              // companyId 별로 모델을 필터링하는데
              // 처음부터 objCompanyId가 없을경우 computed watch 에서 catch못함
              data.objCompanyId = null;
            }
            if (isNil(data.snmpVersion)) {
              data.snmpVersion = 'NONE';
            }

            if (isNil(data.snmpV3AuthProtocol)) {
              data.snmpV3AuthProtocol = 'NONE';
            }

            if (isNil(data.snmpV3PrivProtocol)) {
              data.snmpV3PrivProtocol = 'NONE';
            }
            Object.assign(this.objOriginData, data);
          }
        });
      const hwConfig = () =>
        ndInfoAPI.getNdConfigInfoHwinfo(this.params).then((result) => {
          if (result.data.success) {
            const data = result.data.data;

            if (data && has(data, 'firmwareFile')) {
              data.fileName = data.firmwareFile;
            }
            Object.assign(this.objOriginData, data);
          }
        });

      Promise.all([basicConfig(), hwConfig()])
        .then(() => {
          this.formData = Object.assign({}, this.objOriginData);
          commonAPI
            .getObjCompanyList({
              objCompanyId: this.formData.objCompanyId,
              showFlag: '1',
            })
            .then((res) => {
              this.objCompanyList = res.data.data;
            });
          // 확장 구성 정보 조회 - SKCC
          ndInfoAPI
            .getTargetConfigTemplateAttrInfo({
              objId: this.nodeParams.objId,
              objCompanyId: this.formData.objCompanyId,
              objProductId: this.formData.objProductId,
            })
            .then((res) => {
              if (res.data.success) {
                this.templateAttrValueList = res.data.data;
              }
            });
          this.$emit('setConfigData', this.formData);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    /**
     * 구성 정보를 저장한다.
     * @author Ju
     * @param  {[type]} updateData [description]
     * @param  {[type]} action     [description]
     * @param  {[type]} target     [description]
     * @return {[type]}            [description]
     */
    saveConfig(updateData, action, target) {
      ndInfoAPI
        .updateNdConfigInfo(updateData)
        .then((result) => {
          if (result.data.success) {
            this.$message(MsgUtil.getResultMsgData(action, target, true));
            this.$store.dispatch('endConfigEdit');
            this.loadData();
          } else {
            this.$message(MsgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch(() => {
          this.$message(MsgUtil.getResultMsgData(action, target, true));
        });
    },
    convertDate(value) {
      return isNil(value) ? EMPTY_TEXT : getDateToString(value);
    },
    convertUptimeCount(value) {
      return isNil(value) ? EMPTY_TEXT : `${value}일`;
    },
    initAliveChechGroup(data) {
      const aliveOptionList = [
        {
          key: 'alivecheckFlagSnmp',
          label: 'SNMP',
          value: Number(data.alivecheckFlagSnmp),
        },
        {
          key: 'alivecheckFlagIcmp',
          label: 'ICMP',
          value: Number(data.alivecheckFlagIcmp),
        },
        {
          key: 'alivecheckFlagTcpport',
          label: 'TCP',
          value: Number(data.alivecheckFlagTcpport),
        },
      ];
      this.aliveOptionList = aliveOptionList;
    },
    companyChange() {
      this.formData.objProductId = null;
    },
    updateSubIp(list) {
      this.formData.subIpInfo = list;

      if (isNil(this.formData.modified)) {
        this.formData.modified = {};
      }
      Object.assign(this.formData.modified, {
        subIpInfo: this.originalSubIpInfo,
      });
    },
    authChange(value) {
      if (eq('NONE', value)) {
        this.formData.snmpV3AuthPassword = null;
      }
    },
    privChange(value) {
      if (eq('NONE', value)) {
        this.formData.snmpV3PrivPassword = null;
      }
    },
    setBasicInfoData() {
      commonAPI
        .getObjTypeList({
          managetypeId: 'NMS',
        })
        .then((res) => {
          this.objTypeList = res.data.data;
        });
      commonAPI.getObjProductList({}).then((res) => {
        this.objProductList = res.data.data;
      });
      ndInfoAPI.getFirmwareFullList({}).then((res) => {
        this.firmwareList = res.data.data;
      });
      commonAPI.getMgrInfoList({}).then((res) => {
        this.managerList = res.data.data;
      });

      commonAPI
        .getBasicinfoSubList({
          basicinfoId: 'SNMPVER',
        })
        .then((res) => {
          const list = res.data.data;
          const snmpVersionList = [];

          list.forEach((data) => {
            snmpVersionList.push({
              label: data.basicinfoSubname,
              snmpVersion: data.basicinfoSubid,
            });
          });
          this.snmpVersionList = snmpVersionList;
        });

      commonAPI
        .getBasicinfoSubList({
          basicinfoId: 'SNMPAUTH',
        })
        .then((res) => {
          const list = res.data.data;
          const snmpV3AuthList = [];
          list.forEach((data) => {
            snmpV3AuthList.push({
              label: data.basicinfoSubname,
              snmpV3AuthProtocol: data.basicinfoSubid,
            });
          });
          this.snmpV3AuthList = snmpV3AuthList;
        });

      commonAPI
        .getBasicinfoSubList({
          basicinfoId: 'SNMPPRIV',
        })
        .then((res) => {
          const list = res.data.data;
          const snmpV3PrivList = [];

          list.forEach((data) => {
            snmpV3PrivList.push({
              label: data.basicinfoSubname,
              snmpV3PrivProtocol: data.basicinfoSubid,
            });
          });
          this.snmpV3PrivList = snmpV3PrivList;
        });

      this.basicInfoLoadFlag = true;
    },
    selected(value) {
      this.updateEdit(value);
    },
    openCompanyListPopup() {
      this.$refs.companyListPopup.open();
    },
    applyCompanyId(companyInfo) {
      commonAPI
        .getObjCompanyList({
          objCompanyId: companyInfo.objCompanyId,
          showFlag: '1',
        })
        .then((res) => {
          this.objCompanyList = res.data.data;
        });
      this.formData.objCompanyId = cloneDeep(companyInfo.objCompanyId);
      this.formData.objProductId = null;
    },
    /**
     * managerName 조회
     * @param  {[type]} managerId [description]
     * @return {[type]}           [description]
     * @author jda
     */
    getObjManagerName(managerId) {
      if (isEmpty(managerId)) {
        return EMPTY_TEXT;
      }
      const mgrInfo = this.managerList.find((data) => data.managerId === managerId);
      return isEmpty(mgrInfo) ? EMPTY_TEXT : mgrInfo.managerName;
    },
  },
};
</script>

<style>
.form-list .el-form-item__label {
  text-align: left;
}

.form-header {
  padding-left: 10px;
  height: 25px;
  font-weight: bold;
  font-size: 14px;
  color: #8b8b8b;
}
</style>



// WEBPACK FOOTER //
// src/views/config/node/ap-controller/configstatus/index.vue